import { PureComponent } from 'react';
import { fontFamily } from '../Consts';

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,

} from 'chart.js';

import { Bar } from 'react-chartjs-2'
import annotationPlugin from 'chartjs-plugin-annotation';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    annotationPlugin,
);

export class BarChartStackedMultiple extends PureComponent {

    getColColorStd = (id) => {
        id *= 2;
        const factor = 15;
        const damper = 50;
        const rgb = [61 - damper, 255 - damper, 83 - damper];
        let colString = "rgba(" + (rgb[0] - id * factor) + "," +
            (rgb[1] - id * factor) + "," +
            // (rgb[1]) + "," +
            (rgb[2] - id * factor) +
            ",0.8)";
        return colString;
    }

    getKritBColors = (dc, dcw, c, idx, cp) => {
        let colors = [...dc];
        let af = 1;
        if (af > 0) {
            colors[idx] = c;
        }
        return colors;
    }

    foo = (xxx) => {
        console.log("rolli");
    }

    render() {

        let colorvars = [];
        let i = -1;
        do {
            i++;
            let colorvar = getComputedStyle(document.documentElement).getPropertyValue(
                `--color-wheel-${i + 1}`,
            );
            if (colorvar.length) colorvars.push(colorvar);
        } while (typeof colorvars[i] !== 'undefined');

        const dF = this.props.evalData;
        // const protoExam = dF[0][1];

        const { numTasks, maxPoints } = dF[0][0];

        // const columnColorAtt = colorvars[0];

        const xScaleColorStd = "rgba(100, 100, 100, 0.8)";
        // const xScaleColorAtt = colorvars[2];

        // should be variable, won't work... :/
        const barColorKritB = "rgba(127, 128, 134,1 )";

        let labels = ['0-9%', '10-19%', '20-29%', '30-39%', '40-49%', '50-59%', '60-69%', '70-79%', '80-89%', '90-100%'];
        let numPupils = [];
        let sumNumPupils = 0;
        let xScaleColors = [];
        let xScaleColorsWeight = [];
        let xScaleColorsSize = [];

        // let strLegendKritC = "Kriterium c: relativer Abstand >20%";
        // if (this.props.parentState.criterion_c !== "yes") {
        //     strLegendKritC = "";
        // }

        for (let i = 0; i < numTasks; i++) {
            xScaleColors.push(xScaleColorStd);
            xScaleColorsWeight.push("normal");
            xScaleColorsSize.push(14);
        }

        let maxYAxis = 0;

        let dataSets = [];
        for (let e = 0; e < dF.length; e++) {
            let dp = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            let dc = [];

            numPupils[e] = dF[e][0].numPupils;
            sumNumPupils += numPupils[e];

            let theGrid = dF[e][1].grid;

            for (let i = 0; i < numPupils[e]; i++) {
                let pigeonSlot = Math.trunc((Number(theGrid[i][numTasks + 2].value) / maxPoints) * 10);
                if (pigeonSlot === 10) {
                    pigeonSlot = 9;
                }

                dp[pigeonSlot] += 1;
            }

            for (let t = 0; t < labels.length; t++) {
                dc.push(this.getColColorStd(e));
            }

            dataSets.push({
                label: dF[e][1].klasse + ' in [' + dF[e][1].fach + '] ' + numPupils[e] + ' SuS',

                data: dp,
                backgroundColor: (barElement) => {
                    if (barElement.active === true) {
                        let colors = this.getKritBColors(
                            dc,
                            dc,
                            barColorKritB,
                            barElement.index,
                            this.props.evalData[e][0].crossProducts[barElement.index],
                        );
                        return colors;
                    }
                    else {
                        return dc;
                    }
                },
            })

            for (let i = 0; i < labels.length; i++) {
                let dpSum = 0;
                for (let j = 0; j < dataSets.length; j++) {
                    dpSum += dataSets[j].data[i];
                }
                // dpSum > maxYAxis ? maxYAxis = dpSum : maxYAxis = maxYAxis;
                if (dpSum > maxYAxis) {
                    maxYAxis = dpSum;
                }
            }

        }

        const data = {
            labels,
            datasets: dataSets,
        };

        const options = {
            responsive: true,
            maintainAspectRatio: false,
            elements: {
                bar: {
                    // inflateAmount: -3,
                    inflateAmount: 0,
                },
            },
            scales: {
                x: {
                    stacked: true,
                    ticks: {
                        color: xScaleColors,
                        font: {
                            family: fontFamily,
                            size: xScaleColorsSize,
                            weight: xScaleColorsWeight,
                        },
                    },
                },
                y: {
                    stacked: true,
                    max: maxYAxis + 1,
                    min: 0,
                    ticks: {
                        stepSize: 1,
                        font: {
                            family: fontFamily,
                            size: 14,
                        },
                    },
                },
            },
            plugins: {
                tooltip: {
                    callbacks: {
                        title: (ctx) => {
                            return "Lösungsgrad " + ctx[0].label + " - " + ctx[0].raw + " SuS";
                        },
                        label: (ctx) => {
                            return ctx.dataset.label;
                        },
                    },
                },
                legend: {
                    position: 'top',
                    onClick: (evt, legendItem, legend) => {
                        const datasets = legend.legendItems.map((dataset, index) => {
                            return dataset.text;
                        })
                        const idx = datasets.indexOf(legendItem.text);
                        legend.chart.isDatasetVisible(idx) ? legend.chart.hide(idx) : legend.chart.show(idx);
                    },
                    labels: {
                        generateLabels: (chart) => {
                            let vis = [];
                            for (let i = 0; i < chart.data.datasets.length; i++) {
                                if (chart.isDatasetVisible(i) === false) {
                                    vis.push(true);
                                }
                                else {
                                    vis.push(false);
                                }
                            }

                            return chart.data.datasets.map(
                                (dataset, index) => ({
                                    text: dataset.label,
                                    fillStyle: this.getColColorStd(index),
                                    strokeStyle: "rgba(50, 205, 50, 0.8)",
                                    hidden: vis[index],
                                })
                            )
                        },
                        boxWidth: 20,
                    },
                },
                title: {
                    display: true,
                    text: "Verteilung der Lösungsgrade [" + sumNumPupils + ' SuS]',
                    color: 'grey',
                    font: {
                        size: 20,
                        family: fontFamily,
                        weight: 'normal',
                    },
                },
                annotation: {
                    annotations: {
                        labelNorm: {
                            type: 'label',
                            xValue: -0.37,
                            yValue: maxYAxis / 2,
                            backgroundColor: 'transparent',
                            content: ['Anzahl SuS'],
                            rotation: -90,
                            textAlign: 'left',
                            color: 'grey',
                            font: {
                                size: 12,
                                family: fontFamily,
                            }
                        },
                    }
                },
            },
        };

        return (
            <div className="barSizer">
                <Bar options={options} data={data} />
            </div >
        )
    }
}

export default BarChartStackedMultiple;
